<base-button
	*transloco="let t"
	class="btn-login"
	[variant]="variant()"
	type="submit"
	[loading]="loading() || authService.isLoading"
	[block]="block()"
>
	{{ t('actions.login') }}
</base-button>
